import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import Copyright from '../../commons/Copyright';
import styled from "styled-components";
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { userService } from '../../../services';
import { useHistory } from "react-router-dom";
import { Container } from '@mui/material';
import HeaderPublic from '../../commons/HeaderPublic';
import Form from '../../form/Form';
import { isNotLoginLogin } from '../../../utils/session';

const initProfile = {
    email:"",
    name: "",
    lastname: "",
    phone: "",
    street:"",
    number: "",
    door: "",
    floor:"",
    stairs: "",
    city: "",
    state: "",
    country: "",
    postalcode: "",
};

const initPass = {
    oldpass: "",
    newpass: "",
    repass: "",
};

export default function MiPerfil(props) {
    const { t, i18n } = useTranslation();
    const [profileData,setProfileData] = useState({...initProfile})
    const [passData,setPassData] = useState({...initPass})
    const [loadProfile,setLoadProfile] = useState(false)
    const [loadPass,setLoadPass] = useState(false)
    const [messProfile,setMessProfile] = useState("")
    const [messPass,setMessPass] = useState("")
    const [isErrorProfile,setIsErrorProfile] = useState(false)
    const [isErrorPass,setIsErrorPass] = useState(false)
    let history = useHistory()

    useEffect(()=>{
        if(isNotLoginLogin()){
            history.push("/acceso");
            return;
        }
        userService.myinfo((data, error) => {
            if (data && data.data){
                setProfileData(current => ({...current, ...data.data}));
            }
        });
    },[]);

    const estructureformProfile =  [
        {
         type:"input",
         name: "name",
         col: 4
        },
        {
         type:"input",
         name: "lastname",
         col: 4
        },
        {
         type:"input",
         name: "email",
         inputtype:"email",
         readonly: true,
         col: 4
        },
        {
         type:"input",
         name: "phone",
         col: 4
        },
        {
            type:"title",
            name: "titledir",
            col: 12
        },
        {
         type:"input",
         name: "country",
         col: 4
        },
        {
         type:"input",
         name: "state",
         col: 4
        },
        {
         type:"input",
         name: "city",
         col: 4
        },
        {
         type:"input",
         name: "postalcode",
         col: 4
        },
        {
         type:"input",
         name: "street",
         col: 4
        },
        {
         type:"input",
         name: "number",
         col: 2
        },
        {
         type:"input",
         name: "floor",
         col: 2
        },
        {
         type:"input",
         name: "door",
         col: 2
        },
        {
         type:"input",
         name: "stairs",
         col: 2
        },
    ];

    const estructureformPass =  [
        {
         type:"input",
         name: "oldpass",
         col: 4,
         inputtype: "password"
        },
        {
         type:"input",
         name: "newpass",
         col: 4,
         inputtype: "password"
        },
        {
         type:"input",
         name: "repass",
         col: 4,
         inputtype: "password"
        },
    ];

    const isValidProfile = (object) => {
        if(!object["name"]){
            setMessProfile("Debe indicar el nombre");
            return false;
        } else if(!object["lastname"]){
            setMessProfile("Debe indicar el apellido");
            return false;
        } else {
            return true;
        }
    }

    const isValidPass = (object) => {
        if(!object["oldpass"]){
            setMessPass("Debe indicar la contraseña actual");
            return false;
        } else if(!object["newpass"]){
            setMessPass("Debe indicar la nueva contraseña");
            return false;
        } else if(object["newpass"] != object["repass"]){
            setMessPass("Las contraseñas no coinciden");
            return false;
        } else {
            return true;
        }
    }

    const saveProfile = (object) => {
        setIsErrorProfile(false);
        if(isValidProfile(object)) {
            setMessProfile("");
            setLoadProfile(true);
            userService.editmyinfo(object, (data, error) => {
                setLoadProfile(false);
                if (data && data.data){
                    setProfileData(current => ({...current, ...data.data}));
                    setMessProfile("Datos actualizados correctamente");
                } else {
                    setIsErrorProfile(true);
                    setMessProfile("Ha ocurrido un error. Vuelva a intentarlo mas tarde");
                }
            });
        } else {
            setIsErrorProfile(true);
        }
    }

    const savePass = (object) => {
        setIsErrorPass(false);
        if(isValidPass(object)) {
            setMessPass("");
            setLoadPass(true);
            userService.changepass({oldpass: object["oldpass"], newpass: object["newpass"]}, (data, error) => {
                setLoadPass(false);
                if (data){
                    setPassData({...initPass});
                    setMessPass("Contraseña actualizada correctamente");
                } else {
                    setIsErrorPass(true);
                    setMessPass("No se ha podido cambiar la contraseña. Compruebe la contraseña actual");
                }
            });
        } else {
            setIsErrorPass(true);
        }
    }

    const goBack = (object) => {
        window.location.href = process.env.REACT_APP_PROTECMEDIA + "";
    }

    return (<Main>
            <Container>
            <HeaderPublic style={{margin: "1em 0"}}/>
            <CardLongin>
                <Typography variant="body1" align="center" style={{fontWeight:"bold"}}>Datos personales</Typography>
                <Form t={t} i18n={"miperfil"}  objectform={profileData} fields={estructureformProfile}  searchFilter={saveProfile} cleanFilter={goBack} labelsave={"Guardar"} labelcancel={"Volver"} reload={false} haveMoreActions={false} load={loadProfile}/>
                {messProfile && messProfile != "" && <MessBox error={isErrorProfile}>{messProfile}</MessBox> }
            </CardLongin>
            <CardLongin>
                <Typography variant="body1" align="center" style={{fontWeight:"bold"}}>Cambiar contraseña</Typography>
                <Form t={t} i18n={"miperfil"}  objectform={passData} fields={estructureformPass}  searchFilter={savePass} labelsave={"Cambiar contraseña"} isHiddenCancel={true} reload={false} haveMoreActions={false} load={loadPass}/>
                {messPass && messPass != "" && <MessBox error={isErrorPass}>{messPass}</MessBox> }
            </CardLongin>
            <Copyright />
            </Container>
            </Main>

      );

}

const CardLongin = styled(Card)`
    padding: 1em;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1em;
`;

const Main = styled.div`
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    width: 100%;
    height: 100vh;
    display: flex;
`;

const MessBox = styled.p<{error: boolean}>`
    background: ${props => props.error ? "rgba(255,0,0,0.6)" : "rgba(0,150,0,0.6)"};
    padding: 1em;
    border-radius: 6px;
    margin: 1em 0;
    text-align: center;
    color: ${props => props.error ? "darkred" : "darkgreen"};
    border: 1px solid ${props => props.error ? "darkred" : "darkgreen"};
    width: 100%;
`;
